import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from './authService';

export const bookingDateChangeApi = {
  requestChange: async (bookingId, data) => {
    const response = await api.post(`/bookings/${bookingId}/event-date-change`, data);
    return response.data;
  },

  cancelRequest: async (bookingId) => {
    const response = await api.post(`/bookings/${bookingId}/event-date-change/cancel`);
    return response.data;
  },

  approveChange: async (bookingId) => {
    const response = await api.post(`/vendor/bookings/${bookingId}/event-date-change/approve`);
    return response.data;
  },

  rejectChange: async (bookingId, rejectionReason) => {
    const response = await api.post(`/vendor/bookings/${bookingId}/event-date-change/reject`, {
      rejection_reason: rejectionReason,
    });
    return response.data;
  },
};

export const useRequestEventDateChange = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ bookingId, requested_event_date, client_note }) =>
      bookingDateChangeApi.requestChange(bookingId, {
        requested_event_date,
        client_note,
      }),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['booking', variables.bookingId] });
      queryClient.invalidateQueries({ queryKey: ['vendorBooking', variables.bookingId] });
      options.onSuccess?.();
    },
    onError: options.onError,
  });
};

export const useCancelEventDateChange = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ bookingId }) => bookingDateChangeApi.cancelRequest(bookingId),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['booking', variables.bookingId] });
      options.onSuccess?.();
    },
    onError: options.onError,
  });
};

export const useApproveEventDateChange = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ bookingId }) => bookingDateChangeApi.approveChange(bookingId),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['vendorBooking', variables.bookingId] });
      queryClient.invalidateQueries({ queryKey: ['booking', variables.bookingId] });
      options.onSuccess?.();
    },
    onError: options.onError,
  });
};

export const useRejectEventDateChange = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ bookingId, rejection_reason }) =>
      bookingDateChangeApi.rejectChange(bookingId, rejection_reason),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['vendorBooking', variables.bookingId] });
      queryClient.invalidateQueries({ queryKey: ['booking', variables.bookingId] });
      options.onSuccess?.();
    },
    onError: options.onError,
  });
};
